const messages: Record<string, string> = {
	'loader.loading': 'Cargando datos...',
	'loader.error':
		'No se ha podido cargar la información. Por favor, inténtalo de nuevo más tarde...',
	'connectionError.title': 'Error de conexión',
	'connectionError.description': 'Error de conexión. Por favor, adjunta la imagen de nuevo.',
	'mainError.tryAgain': 'Inténtalo de nuevo',
	'landing.headline.policyCheck': 'Bienvenido/a',
	'landing.paragraph': 'Estás a tres pasos de finalizar el proceso',
	'landing.stepDescription.fourAdditionalPictures': 'Sube las fotos',
	'landing.stepDescription.fourDiagonalPerspectives': 'Haz las fotos que necesitamos',
	'landing.stepDescription.feedback': 'Danos tu opinión',
	'landing.termsAndConditionsLinkDescription': ' ',
	'landing.termsAndConditionsLink': 'Acepto los términos y condiciones',
	'button.start': 'Iniciar',
	'landing.aboutPolicyCheck': '¿Qué es la verificación digital?',
	'chooseLang.headline': 'Elige tu idioma preferido',
	'button.close': 'Cerrar',
	'tutorialModal.headline.first.policyCheck': ' ',
	'tutorialModal.paragraph.second':
		'La verificación digital es una comprobación rápida del estado del vehículo. El proceso de verificación digital consta de 8 sencillos pasos.',
	'tutorialModal.paragraph.first.policyCheck': ' ',

	'landing.additional-informations-section.title':
		'Antes de iniciar la verificación de tu vehículo, comprueba que:',
	'landing.additional-informations-section.text':
		'<ul><li>Tienes las llaves y el permiso de circulación a mano</li><li>Estás en un lugar con buena luz y red móvil / Internet</li><li>Puedes acceder al vehículo desde todos los ángulos y todas las ventanillas laterales están cerradas.</li></ul>',

	'vehicleImages.overviewPhotos': 'Vista general del vehículo',
	'vehicleImages.overviewPhotos.subtitle': 'Haz las fotos de tu vehículo',
	'vehicleImages.description':
		'Haz una foto de tu vehículo en diagonal desde la parte delantera izquierda y derecha y desde la parte trasera izquierda y derecha. La matrícula se tiene que ver en todas las imágenes.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Foto diagonal delantera izquierda',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Foto diagonal trasera izquierda',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Foto diagonal trasera derecha',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Foto diagonal delantera derecha',
	'button.next': 'Siguiente',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Foto de ejemplo',
	'imageRecognitionMismatchModal.headline': 'Comprueba que has adjuntado la foto correcta',
	'button.continue': 'Continuar',
	'button.backchangeImage': 'Atrás y cambiar foto',
	'completeVehicleImagesModal.headline': 'Ayuda',
	'completeVehicleImagesModal.description': 'Por favor adjunta las siguientes fotos',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Foto diagonal delantera izquierda',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Foto diagonal trasera izquierda',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Foto diagonal trasera derecha',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Foto diagonal delantera derecha',
	'button.changeImage': 'Cambiar la foto',
	'button.deleteImage': 'Eliminar la foto',
	'vehicleImages.leftFrontOverview': 'Foto diagonal delantera izquierda',
	'vehicleImages.leftRearOverview': 'Foto diagonal trasera izquierda',
	'vehicleImages.rightRearOverview': 'Foto diagonal trasera derecha',
	'vehicleImages.rightFrontOverview': 'Foto diagonal delantera derecha',
	'fourPerspectivesExampleModal.headline.first': 'Foto de ejemplo',
	'fourPerspectivesExampleModal.button.close': 'Cerrar',
	'fourAdditionalPictures.title': 'Fotos adicionales',
	'fourAdditionalPictures.overallDashboard.title': 'Salpicadero del vehículo',
	'fourAdditionalPictures.overallDashboard.description':
		'Haz una foto completa del salpicadero de tu vehículo',
	'fourAdditionalPictures.mileage.title': 'Cuentakilómetros',
	'dashboardMileage.dashboard.paragraph':
		'Haz una foto de los kilómetros recorridos. Si tu vehículo tiene una pantalla digital, enciéndela.',
	'dashboardMileage.paragraph.first': 'Indica el kilometraje de tu vehículo',
	'dashboardMileage.placeholder': 'Por ejemplo: 150.000 km',
	'fourAdditionalPictures.windshield.title': 'Parabrisas delantero del vehículo',
	'fourAdditionalPictures.windshield.description':
		'Haz una foto completa del parabrisas delantero de tu vehículo.',
	'fourAdditionalPictures.vin.title': 'Número de bastidor del vehículo',
	'fourAdditionalPictures.vin.description':
		'Haz una foto del número de bastidor de tu vehículo. Puedes encontrar este dato: debajo del capó, en el motor, bajo el asiento del copiloto, salpicadero o puerta del conductor.',
	'overallDashboardImage.title': 'Imagen general del salpicadero',
	'dashboardMileage.dashboard.title': 'Foto del kilometraje',
	'windshieldImage.title': 'Foto del parabrisas',
	'vinPicture.title': 'Foto del número de bastidor',
	'completeFourAdditionalPicturesModal.headline': 'Ayuda',
	'completeFourAdditionalPicturesModal.description': 'Por favor, adjunta la siguiente información:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Foto del salpicadero del vehículo',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Foto del kilometraje',
	'completeDashboardMileageModal.hasValidMileage': 'Kilometraje',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Foto del número de bastidor del vehículo',
	'completeFourAdditionalPicturesModal.hasWindshieldImage':
		'Foto del parabrisas delantero del vehículo',

	'fourAdditionalDocuments.RegistrationDocument.description':
		'Haz una foto del permiso de circulación (por delante).',
	'fourAdditionalDocuments.RegistrationDocumentInside.description':
		'Haz una foto del permiso de circulación (por detrás).',
	'fourAdditionalDocuments.VehicleDatasheetOutside.description':
		'Haz una foto de la ficha técnica del vehículo (por delante).',
	'fourAdditionalDocuments.VehicleDatasheetInside.description':
		'Haz una foto de la ficha técnica del vehículo (por detrás).',

	'feedback.headline.policyCheck': 'Fotos recibidas correctamente',
	'feedback.description': ' ',
	'feedback.rating.policyCheck':
		'¿Con cuántas estrellas calificarías tu experiencia con el proceso de verificación digital, siendo 5 la mejor puntuación?',
	'feedback.yourOpinion': '¿Tienes algún comentario?',
	'feedback.button.send': 'Enviar',
	'waitForAudit.thankYou': 'Agradecemos tu opinión',
	'waitForAudit.description.damageFound': 'Gracias por confiar en BBVA Allianz',
	'thanks.headline.first': '¡Gracias!',
	'thanks.paragraph.first': 'Gracias por confiar en BBVA Allianz',

	'fourAdditionalPictures.overallDashboard.exampleModalTitle':
		'Foto de ejemplo - Foto del salpicadero del vehículo',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Foto de ejemplo - Foto del kilometraje',
	'fourAdditionalPictures.windshield.exampleModalTitle':
		'Foto de ejemplo - Foto del parabrisas delantero del vehículo',
	'fourAdditionalPictures.vin.exampleModalTitle':
		'Foto de ejemplo - Foto del número de bastidor del vehículo',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Foto diagonal delantera izquierda',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Foto diagonal trasera izquierda',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Foto diagonal trasera derecha',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Foto diagonal delantera derecha',

	'blockedByDevice.headline': 'PolicyCheck no permite el uso de navegadores de escritorio',
	'blockedByDevice.description':
		'Se ha detectado que estás usando un navegador de escritorio. La plataforma PolicyCheck solo se puede utilizar a través de un dispositivo móvil. Para continuar, abre el enlace desde un dispositivo móvil.',

	'invalidFile.size.title': 'Tamaño de imagen incorrecto',
	'invalidFile.size.description': 'El tamaño de la imagen es mayor que el máximo requerido.',
	'invalidFile.extension.title': 'El tipo de archivo no es compatible',
	'invalidFile.extension.description':
		'El tipo de archivo adjuntado no es compatible. Tipos de archivo admitidos: .jpg, .jpeg, .jfif, .heic, .heif, .png y .bmp',
};

export default messages;
